import { render, staticRenderFns } from "./shopList.vue?vue&type=template&id=35e81c78&scoped=true"
import script from "./shopList.vue?vue&type=script&lang=ts"
export * from "./shopList.vue?vue&type=script&lang=ts"
import style0 from "./shopList.vue?vue&type=style&index=0&id=35e81c78&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e81c78",
  null
  
)

export default component.exports